import { ReactNode, useEffect } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isRangeSelection, LexicalEditor } from 'lexical';

import { Box } from '../../../../Box';
import { $createMentionNode } from '../../nodes';

type Props = {
  children: ReactNode;
  mention: boolean;
};

const listener = (event: KeyboardEvent, editor?: LexicalEditor) => {
  if (event.key === '@' && event.shiftKey) {
    event.preventDefault();

    if (editor) {
      editor.update(() => {
        const selection = $getSelection();

        if ($isRangeSelection(selection)) {
          const mentionNode = $createMentionNode();

          selection.insertNodes([mentionNode]);
        }
      });
    }
  }
};

export const MentionPlugin = ({ children, mention }: Props) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!mention) return;

    const removeRootListener = editor.registerRootListener(
      (rootElement, prevRootElement) => {
        rootElement?.addEventListener('keydown', (e) => listener(e, editor));

        prevRootElement?.removeEventListener('keydown', (e) =>
          listener(e, editor),
        );
      },
    );

    return () => {
      removeRootListener();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Box>{children}</Box>;
};
